import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const RackList = Loadable(lazy(() => import("features/rack/components/List")));
const RackPage = Loadable(lazy(() => import("features/rack/components/Page")));
const routes = {
  path: "rack",
  children: [
    { path: "", element: <RackList /> },
    { path: "add", element: <RackPage /> },
    { path: "edit/:rackID?", element: <RackPage /> },
  ],
};

export default routes;
